<template>
<div class="wordhomw-wrap">
  <div data-v-7a63e4b3="" class="v-note-wrapper markdown-body shadow"><h1><a id="_0"></a>单点登录</h1>
    <ul>
      <li><a href="#">单点登录流程</a></li>
      <li><a href="#">CAS服务器搭建</a></li>
      <li><a href="#">后端对接CAS</a></li>
      <li><a href="#">Vue前端开启CAS登录</a></li>
    </ul>
  </div>

</div>
</template>

<script>
export default {
  name: "wordCom112"
}
</script>

<style scoped>

</style>
